/* ============================================================================
   Color picker v2 — engine.

   Isolated replacement for the colors.kompozitusa.com iframe picker. Loaded by
   snippets/color-picker-v2.liquid; that snippet is the ONLY integration point,
   so adding the picker anywhere else is a single {% render %} line.

   Live for every visitor. Scope is bounded by the snippet, not by this file:
   it renders only for products tagged "PM Color Choose" and only where the
   {% render %} was placed. The properties[Color number] value it writes was
   verified end-to-end against the live store — Shopify keeps it on the cart
   line and shows it in cart and checkout.

   Talks to the colors-api JSON endpoints directly (public, CORS-open, no auth):
     GET /api/v2/tables/colors/count
     GET /api/v2/tables/colors?limit=&offset=
     GET /api/v2/tables/colors/search?value=<Family>&columns=group
     GET /api/v2/search?value=<query>            (fuzzy T9)
   All respond as { data: "<base64 JSON array-of-arrays>" } or { message: "..." }.
   Reliable column indices: 0=id, 1=code, 2=name, 3=hex.
   ========================================================================= */
(function () {
  if (window.KompozitColorPickerV2) return;

  var API_BASE = 'https://colors.kompozitusa.com/api/v2';
  var PAGE_SIZE = 49; // same page size the iframe used
  var FAMILIES = ['White', 'Grey', 'Brown', 'Blue', 'Purple', 'Red', 'Orange', 'Yellow', 'Green'];

  var ICON_CLOSE =
    '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99486 7.00636C6.60433 7.39689 6.60433 8.03005 6.99486 8.42058L10.58 12.0057L6.99486 15.5909C6.60433 15.9814 6.60433 16.6146 6.99486 17.0051C7.38538 17.3956 8.01855 17.3956 8.40907 17.0051L11.9942 13.4199L15.5794 17.0051C15.9699 17.3956 16.6031 17.3956 16.9936 17.0051C17.3841 16.6146 17.3841 15.9814 16.9936 15.5909L13.4084 12.0057L16.9936 8.42059C17.3841 8.03007 17.3841 7.3969 16.9936 7.00638C16.603 6.61585 15.9699 6.61585 15.5794 7.00638L11.9942 10.5915L8.40907 7.00636C8.01855 6.61584 7.38538 6.61584 6.99486 7.00636Z" fill="#1e2618"></path></svg>';

  var ICON_SEARCH =
    '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.0392 15.6244C18.2714 14.084 19.0082 12.1301 19.0082 10.0041C19.0082 5.03127 14.9769 1 10.0041 1C5.03127 1 1 5.03127 1 10.0041C1 14.9769 5.03127 19.0082 10.0041 19.0082C12.1301 19.0082 14.084 18.2714 15.6244 17.0392L21.2921 22.707C21.6828 23.0977 22.3163 23.0977 22.707 22.707C23.0977 22.3163 23.0977 21.6828 22.707 21.2921L17.0392 15.6244ZM10.0041 17.0173C6.1308 17.0173 2.99087 13.8774 2.99087 10.0041C2.99087 6.1308 6.1308 2.99087 10.0041 2.99087C13.8774 2.99087 17.0173 6.1308 17.0173 10.0041C17.0173 13.8774 13.8774 17.0173 10.0041 17.0173Z" fill="#1e2618"></path></svg>';

  var ICON_ARROW =
    '<svg width="20" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#1e2618" d="M685.248 104.704a64 64 0 010 90.496L368.448 512l316.8 316.8a64 64 0 01-90.496 90.496L232.704 557.248a64 64 0 010-90.496l362.048-362.048a64 64 0 0190.496 0z"></path></svg>';

  // The palette mark lives in the snippet (it is a detailed multi-colour SVG,
  // ~7 KB) and is cloned from the trigger row rather than shipped a second time
  // in this bundle. A confirmation can only ever be raised by a form that has a
  // row, so the source node is always present by then.
  function paletteIconHtml() {
    var src = document.querySelector('[data-cpv2-icon] svg');
    return src ? src.cloneNode(true).outerHTML : '';
  }

  var state = {
    mode: 'browse', // 'browse' | 'family' | 'search'
    family: null,
    query: '',
    page: 0,
    totalItems: 0,
    totalPages: 0,
    loading: false,
    row: null // the [data-cpv2-row] the open picker will write into
  };

  var els = {};
  var built = false;

  var confirmEl = null;
  var pendingForm = null;

  /* — helpers — */

  function decodeBase64Json(b64) {
    var binary = atob(b64);
    var bytes = Uint8Array.from(binary, function (c) { return c.charCodeAt(0); });
    return JSON.parse(new TextDecoder('utf-8').decode(bytes));
  }

  // DB stores names lowercase ("pure white"); title-case them so the value
  // written into properties[Color number] matches the "Pure White" fallback.
  function titleCase(str) {
    return String(str || '').replace(/\S+/g, function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* — the colour row: two states, "nothing picked" and "picked" — */

  function applySelection(row, name, code, hex) {
    if (!row) return '';
    var input = row.querySelector('[data-cpv2-input]');
    var swatch = row.querySelector('[data-cpv2-swatch]');
    var nameEl = row.querySelector('[data-cpv2-name]');
    var codeEl = row.querySelector('[data-cpv2-code]');
    var value = (name + ' ' + code).trim();

    if (input) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (swatch) swatch.style.backgroundColor = hex;
    if (nameEl) nameEl.textContent = name;
    if (codeEl) codeEl.textContent = code;
    row.classList.add('is-selected');
    return value;
  }

  /* — overlay construction (once, lazily, on <body> so no stacking context traps it) — */

  function build() {
    var overlay = document.createElement('div');
    overlay.className = 'cpv2-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Choose your color');

    overlay.innerHTML =
      '<button type="button" class="cpv2-close" aria-label="Close">' + ICON_CLOSE + '</button>' +
      '<div class="cpv2-search">' +
        '<label class="cpv2-search-label" for="cpv2-search-input">Search Colors:</label>' +
        '<input type="text" id="cpv2-search-input" class="cpv2-search-input" placeholder="Enter color name or code">' +
        '<button type="button" class="cpv2-search-btn" aria-label="Search">' + ICON_SEARCH + '</button>' +
      '</div>' +
      '<div class="cpv2-sorting"></div>' +
      '<div class="cpv2-grid"></div>' +
      '<div class="cpv2-pagination">' +
        '<div class="cpv2-count-info"></div>' +
        '<div class="cpv2-pagination-nums">' +
          '<button type="button" class="cpv2-prev" aria-label="Previous page">' + ICON_ARROW + '</button>' +
          '<ul class="cpv2-page-list"></ul>' +
          '<ul class="cpv2-page-list-mobile"></ul>' +
          '<button type="button" class="cpv2-next" aria-label="Next page">' + ICON_ARROW + '</button>' +
        '</div>' +
        '<span class="cpv2-page-info"></span>' +
      '</div>';

    document.body.appendChild(overlay);

    els.overlay = overlay;
    els.close = overlay.querySelector('.cpv2-close');
    els.searchInput = overlay.querySelector('.cpv2-search-input');
    els.searchBtn = overlay.querySelector('.cpv2-search-btn');
    els.sorting = overlay.querySelector('.cpv2-sorting');
    els.grid = overlay.querySelector('.cpv2-grid');
    els.pagination = overlay.querySelector('.cpv2-pagination');
    els.countInfo = overlay.querySelector('.cpv2-count-info');
    els.pageInfo = overlay.querySelector('.cpv2-page-info');
    els.pageList = overlay.querySelector('.cpv2-page-list');
    els.pageListMobile = overlay.querySelector('.cpv2-page-list-mobile');
    els.prev = overlay.querySelector('.cpv2-prev');
    els.next = overlay.querySelector('.cpv2-next');

    FAMILIES.forEach(function (fam) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'cpv2-sorting-item';
      item.setAttribute('data-sort', fam);
      item.setAttribute('aria-label', fam);
      item.addEventListener('click', function () {
        // Clicking the active family again clears it — the iframe had no way
        // back to the full list without a reload.
        setFamily(state.mode === 'family' && state.family === fam ? null : fam);
      });
      els.sorting.appendChild(item);
    });

    els.close.addEventListener('click', close);
    els.searchBtn.addEventListener('click', runSearch);
    els.searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        runSearch();
      }
    });

    els.prev.addEventListener('click', function () {
      if (state.mode !== 'browse') return;
      state.page = state.page === 0 ? state.totalPages - 1 : state.page - 1;
      fetchPage();
    });
    els.next.addEventListener('click', function () {
      if (state.mode !== 'browse') return;
      state.page = state.page === state.totalPages - 1 ? 0 : state.page + 1;
      fetchPage();
    });

    built = true;
  }

  /* — modes — */

  function setActiveFamily(fam) {
    els.sorting.querySelectorAll('.cpv2-sorting-item').forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-sort') === fam);
    });
  }

  function setFamily(fam) {
    setActiveFamily(fam);
    els.searchInput.value = '';
    if (fam) {
      state.mode = 'family';
      state.family = fam;
    } else {
      state.mode = 'browse';
      state.family = null;
      state.page = 0;
    }
    fetchPage();
  }

  function runSearch() {
    var value = els.searchInput.value.trim();
    if (!value) {
      setFamily(null);
      return;
    }
    setActiveFamily(null);
    state.mode = 'search';
    state.query = value;
    fetchPage();
  }

  /* — data — */

  function currentUrl() {
    if (state.mode === 'search') {
      return API_BASE + '/search?value=' + encodeURIComponent(state.query);
    }
    if (state.mode === 'family') {
      return API_BASE + '/tables/colors/search?value=' + encodeURIComponent(state.family) + '&columns=group';
    }
    return API_BASE + '/tables/colors?limit=' + PAGE_SIZE + '&offset=' + state.page * PAGE_SIZE;
  }

  function setStatus(text) {
    els.grid.innerHTML = '<div class="cpv2-status">' + escapeHtml(text) + '</div>';
  }

  function fetchTotal() {
    return fetch(API_BASE + '/tables/colors/count')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        state.totalItems = d.count || 0;
        state.totalPages = Math.max(1, Math.ceil(state.totalItems / PAGE_SIZE));
      })
      .catch(function () { /* pagination labels just stay empty */ });
  }

  function fetchPage() {
    if (state.loading) return;
    state.loading = true;
    setStatus('Loading colors…');

    fetch(currentUrl())
      .then(function (r) { return r.json(); })
      .then(function (payload) {
        state.loading = false;
        if (!payload || !payload.data) {
          setStatus(payload && payload.message ? payload.message : 'No results. Try again.');
          els.pagination.hidden = true;
          return;
        }
        var rows = decodeBase64Json(payload.data);
        renderRows(rows);
        if (state.mode === 'browse') {
          els.pagination.hidden = false;
          updatePagination(rows.length);
        } else {
          els.pagination.hidden = true;
        }
      })
      .catch(function () {
        state.loading = false;
        setStatus('Searching error. Try again later');
        els.pagination.hidden = true;
      });
  }

  /* — rendering — */

  function renderRows(rows) {
    els.grid.innerHTML = '';
    if (!rows.length) {
      setStatus('No results. Try again.');
      return;
    }

    rows.forEach(function (row) {
      var code = row[1] || '';
      var name = titleCase(row[2] || '');
      var hex = row[3] || '#ffffff';

      var box = document.createElement('button');
      box.type = 'button';
      box.className = 'cpv2-box';
      box.style.backgroundColor = hex;
      box.title = name + ' ' + code;

      var nameEl = document.createElement('span');
      nameEl.textContent = name;

      var codeEl = document.createElement('span');
      codeEl.textContent = code;
      codeEl.style.display = 'none';

      box.appendChild(nameEl);
      box.appendChild(codeEl);

      // Same hover behaviour as the iframe: name by default, code on hover.
      box.addEventListener('mouseenter', function () {
        nameEl.style.display = 'none';
        codeEl.style.display = 'block';
      });
      box.addEventListener('mouseleave', function () {
        nameEl.style.display = 'block';
        codeEl.style.display = 'none';
      });

      box.addEventListener('click', function () {
        select(name, code, hex);
      });

      els.grid.appendChild(box);
    });
  }

  function updatePagination(itemsOnPage) {
    els.pageInfo.textContent = 'Page ' + (state.page + 1) + ' of ' + state.totalPages;
    els.countInfo.textContent =
      'Showing ' + (state.page * PAGE_SIZE + 1) +
      '-' + (state.page * PAGE_SIZE + itemsOnPage) +
      ' of ' + state.totalItems;

    els.prev.innerHTML = state.page === 0 ? 'Last Page' : ICON_ARROW;
    els.next.innerHTML = state.page === state.totalPages - 1 ? 'First Page' : ICON_ARROW;

    els.pageList.innerHTML = '';
    els.pageListMobile.textContent = (state.page + 1) + ' of ' + state.totalPages;

    var maxButtons = 5;
    var start = Math.max(state.page - Math.floor(maxButtons / 2), 0);
    var end = Math.min(start + maxButtons, state.totalPages);
    if (end - start < maxButtons) start = Math.max(end - maxButtons, 0);

    for (var i = start; i < end; i++) {
      (function (index) {
        var li = document.createElement('li');
        li.className = 'cpv2-page-item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cpv2-page-btn' + (index === state.page ? ' active' : '');
        btn.textContent = index + 1;
        btn.addEventListener('click', function () {
          state.page = index;
          fetchPage();
        });
        li.appendChild(btn);
        els.pageList.appendChild(li);
      })(i);
    }
  }

  /* — selection — */

  function select(name, code, hex) {
    var row = state.row;
    var value = applySelection(row, name, code, hex);
    document.dispatchEvent(new CustomEvent('kompozit:colorSelected', {
      detail: { value: value, name: name, code: code, hex: hex, row: row }
    }));
    close();
  }

  /* — open / close — */

  function open(row) {
    if (!built) {
      build();
      // The overlay is parked one viewport to the right and slides in when
      // .is-open lands. On the very first open the element is inserted and the
      // class added in the same frame, so the browser has no "before" state to
      // animate from — reading offsetWidth forces the layout that gives it one.
      void els.overlay.offsetWidth;
    }
    state.row = row || null;

    els.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (!els.grid.children.length && !state.loading) {
      fetchTotal().then(fetchPage);
    }
    setTimeout(function () { els.searchInput.focus(); }, 50);
  }

  function close() {
    if (!built) return;
    els.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    state.row = null;
  }

  function isOpen() {
    return built && els.overlay.classList.contains('is-open');
  }

  /* — "no colour picked" confirmation on add-to-cart — */

  function buildConfirm() {
    confirmEl = document.createElement('div');
    confirmEl.className = 'cpv2-confirm';
    confirmEl.innerHTML =
      '<div class="cpv2-confirm__backdrop" data-cpv2-confirm-cancel></div>' +
      '<div class="cpv2-confirm__panel" role="alertdialog" aria-modal="true" aria-labelledby="cpv2-confirm-title">' +
        // A pair: the palette you skipped → the plain white can you get.
        '<div class="cpv2-confirm__icons" aria-hidden="true">' +
          '<span class="cpv2-confirm__icon">' + paletteIconHtml() + '</span>' +
          '<span class="cpv2-confirm__icons-sep">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M5 12h13"></path><path d="M13 6l6 6-6 6"></path>' +
            '</svg>' +
          '</span>' +
          '<span class="cpv2-confirm__swatch" data-cpv2-confirm-swatch></span>' +
        '</div>' +
        '<h3 class="cpv2-confirm__title" id="cpv2-confirm-title">No color selected</h3>' +
        '<p class="cpv2-confirm__text">' +
          'This can will <strong>not be tinted</strong>. You will get plain ' +
          '<strong data-cpv2-confirm-name>Pure White</strong> exactly as it comes — ' +
          'no color added.' +
        '</p>' +
        '<div class="cpv2-confirm__actions">' +
          '<button type="button" class="cpv2-confirm__pick">Choose a color</button>' +
          '<button type="button" class="cpv2-confirm__go">Continue with white</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(confirmEl);

    confirmEl.querySelector('[data-cpv2-confirm-cancel]').addEventListener('click', closeConfirm);
    confirmEl.querySelector('.cpv2-confirm__pick').addEventListener('click', pickFromConfirm);
    confirmEl.querySelector('.cpv2-confirm__go').addEventListener('click', continueWithFallback);
  }

  // The input is either a DOM descendant of the form (landing quick-add modal)
  // or associated via the form="" attribute (main PDP, where the row renders
  // above the quantity selector, outside the <form>). Both must resolve.
  function inputOf(form) {
    return form.querySelector('[data-cpv2-input]') ||
      (form.id ? document.querySelector('[data-cpv2-input][form="' + form.id + '"]') : null);
  }

  // White is the untinted base, so its "code" is deliberately empty — name and
  // code are separate attributes rather than one "Name Code" string that would
  // have to be split back apart (and "Pure White" splits wrong: "Pure" + "White").
  function fallbackOf(form) {
    var input = inputOf(form);
    return {
      input: input,
      row: input ? input.closest('[data-cpv2-row]') : form.querySelector('[data-cpv2-row]'),
      name: (input && input.getAttribute('data-cpv2-fallback')) || 'Pure White',
      code: (input && input.getAttribute('data-cpv2-fallback-code')) || '',
      hex: (input && input.getAttribute('data-cpv2-fallback-hex')) || '#ffffff'
    };
  }

  function openConfirm(form) {
    if (!confirmEl) buildConfirm();
    pendingForm = form;
    var fb = fallbackOf(form);
    confirmEl.querySelector('[data-cpv2-confirm-name]').textContent = fb.name;
    confirmEl.querySelector('[data-cpv2-confirm-swatch]').style.backgroundColor = fb.hex;
    confirmEl.classList.add('is-open');
    confirmEl.querySelector('.cpv2-confirm__pick').focus();
  }

  function closeConfirm() {
    if (!confirmEl) return;
    confirmEl.classList.remove('is-open');
    pendingForm = null;
  }

  function isConfirmOpen() {
    return !!confirmEl && confirmEl.classList.contains('is-open');
  }

  function pickFromConfirm() {
    var form = pendingForm;
    closeConfirm();
    if (form) {
      var row = fallbackOf(form).row;
      if (row) open(row);
    }
  }

  function continueWithFallback() {
    var form = pendingForm;
    if (!form) return closeConfirm();
    var fb = fallbackOf(form);
    // Writing the fallback in makes the choice explicit: the row now shows the
    // colour, and the property carries it to the order.
    applySelection(fb.row, fb.name, fb.code, fb.hex);
    closeConfirm();
    // Re-submit: the guard below now sees a non-empty value and lets it through
    // to <product-form>.
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  /* — wiring — */

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-cpv2-open]');
    if (!trigger) return;
    evt.preventDefault();
    open(trigger.closest('[data-cpv2-row]'));
  });

  // Capture phase on document, so this runs BEFORE the form's own submit
  // listener (<product-form> binds one in its constructor) and can cancel it.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.nodeName !== 'FORM') return;
    var input = inputOf(form);
    if (!input || input.disabled) return;   // picker inactive here → untouched
    if (input.value.trim()) return;         // colour chosen → straight through
    evt.preventDefault();
    evt.stopPropagation();
    openConfirm(form);
  }, true);

  // Capture phase: while the picker or the confirmation is open, swallow
  // Escape/arrows so the host quick-add modal (dbpl-quick-add.js listens on
  // document, bubble phase) doesn't close itself or flip its gallery behind us.
  document.addEventListener('keydown', function (evt) {
    if (isConfirmOpen()) {
      if (evt.key === 'Escape') {
        evt.stopPropagation();
        closeConfirm();
      }
      return;
    }
    if (!isOpen()) return;
    if (evt.key === 'Escape') {
      evt.stopPropagation();
      close();
      return;
    }
    if (evt.key === 'ArrowLeft' || evt.key === 'ArrowRight') {
      evt.stopPropagation();
    }
  }, true);

  /* The ?debug=1 gate and its localStorage ON/OFF switch are gone — the picker
     is live wherever the snippet renders. Browsers that tested it still hold an
     orphan `cpv2:debug` key; nothing reads it any more, so it is harmless.
     To gate this again anywhere, render the input `disabled`: the submit guard
     above skips a disabled input and FormData excludes it. */

  window.KompozitColorPickerV2 = { open: open, close: close, isOpen: isOpen };
})();
